/**
 * Rental FAQ data — Prompt 11.
 * Four categories with EN/ES/RU Q&A. Used by RentalFAQ page and JSON-LD.
 */

export const FAQ_CATEGORIES = [
  { key: "availability", title: { en: "Rental & availability", es: "Alquiler y disponibilidad", ru: "Аренда и доступность" } },
  { key: "documents",    title: { en: "Documents & conditions", es: "Documentos y condiciones", ru: "Документы и условия" } },
  { key: "delivery",     title: { en: "Delivery & service areas", es: "Entrega y zonas", ru: "Доставка и зоны" } },
  { key: "events",       title: { en: "Events & experiences", es: "Eventos y experiencias", ru: "Мероприятия и впечатления" } },
];

const FAQ_TRANSLATIONS = {
  "Where can I rent a luxury car in Benidorm?": {
    "fr": {
      "q": "Comment louer une voiture de luxe à Benidorm ?",
      "a": "Réservez directement via WhatsApp. La livraison et la remise du véhicule sont assurées à Benidorm et sur toute la Costa Blanca."
    },
    "de": {
      "q": "Wie kann ich in Benidorm einen Luxuswagen mieten?",
      "a": "Buchen Sie direkt per WhatsApp. Abholung und Lieferung sind in Benidorm und an der gesamten Costa Blanca möglich."
    },
    "it": {
      "q": "Come noleggiare un'auto di lusso a Benidorm?",
      "a": "Prenota direttamente tramite WhatsApp. Ritiro e consegna disponibili a Benidorm e su tutta la Costa Blanca."
    },
    "nl": {
      "q": "Hoe huur ik een luxe auto in Benidorm?",
      "a": "Boek rechtstreeks via WhatsApp. Ophalen en bezorgen kan in Benidorm en aan de hele Costa Blanca."
    },
    "pl": {
      "q": "Jak wynająć luksusowy samochód w Benidorm?",
      "a": "Rezerwuj bezpośrednio przez WhatsApp. Odbiór i dostawa pojazdu w Benidorm i na całej Costa Blanca."
    }
  },
  "Can I rent a sports car in Alicante?": {
    "fr": {
      "q": "Puis-je louer une voiture de sport à Alicante ?",
      "a": "Oui. Nous intervenons à Alicante, San Juan, El Campello et Villajoyosa."
    },
    "de": {
      "q": "Kann ich in Alicante einen Sportwagen mieten?",
      "a": "Ja. Wir bedienen Kunden in Alicante, San Juan, El Campello und Villajoyosa."
    },
    "it": {
      "q": "Posso noleggiare un'auto sportiva ad Alicante?",
      "a": "Sì. Serviamo clienti ad Alicante, San Juan, El Campello e Villajoyosa."
    },
    "nl": {
      "q": "Kan ik een sportwagen huren in Alicante?",
      "a": "Ja. Wij bedienen klanten in Alicante, San Juan, El Campello en Villajoyosa."
    },
    "pl": {
      "q": "Czy mogę wynająć sportowy samochód w Alicante?",
      "a": "Tak. Obsługujemy klientów w Alicante, San Juan, El Campello i Villajoyosa."
    }
  },
  "Do you rent cars in Costa Blanca?": {
    "fr": {
      "q": "Louez-vous des voitures sur la Costa Blanca ?",
      "a": "Oui. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja et leurs environs."
    },
    "de": {
      "q": "Vermieten Sie Fahrzeuge an der Costa Blanca?",
      "a": "Ja. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja und die umliegenden Gebiete."
    },
    "it": {
      "q": "Noleggiate auto sulla Costa Blanca?",
      "a": "Sì. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja e dintorni."
    },
    "nl": {
      "q": "Verhuren jullie auto's aan de Costa Blanca?",
      "a": "Ja. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja en omgeving."
    },
    "pl": {
      "q": "Czy wypożyczacie samochody na Costa Blanca?",
      "a": "Tak. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja i okolice."
    }
  },
  "Can I rent an American muscle car in Spain?": {
    "fr": {
      "q": "Peut-on louer une muscle car américaine en Espagne ?",
      "a": "Oui. Dodge Challenger, Dodge Charger et Chevrolet Camaro font généralement partie de notre flotte."
    },
    "de": {
      "q": "Kann man in Spanien ein amerikanisches Muscle Car mieten?",
      "a": "Ja. Dodge Challenger, Dodge Charger und Chevrolet Camaro gehören in der Regel zu unserer Flotte."
    },
    "it": {
      "q": "È possibile noleggiare una muscle car americana in Spagna?",
      "a": "Sì. Dodge Challenger, Dodge Charger e Chevrolet Camaro fanno tipicamente parte della nostra flotta."
    },
    "nl": {
      "q": "Kan ik een Amerikaanse muscle car huren in Spanje?",
      "a": "Ja. Dodge Challenger, Dodge Charger en Chevrolet Camaro maken doorgaans deel uit van ons wagenpark."
    },
    "pl": {
      "q": "Czy można wynająć amerykański muscle car w Hiszpanii?",
      "a": "Tak. Dodge Challenger, Dodge Charger i Chevrolet Camaro zazwyczaj znajdują się w naszej flocie."
    }
  },
  "Do you offer luxury SUVs?": {
    "fr": {
      "q": "Proposez-vous des SUV de luxe ?",
      "a": "Oui. Des SUV premium sont disponibles pour les familles, les déplacements professionnels et les livraisons en hôtel."
    },
    "de": {
      "q": "Haben Sie Luxus-SUVs im Angebot?",
      "a": "Ja. Premium-SUVs sind für Familien, Geschäftsreisen und Hotellieferungen verfügbar."
    },
    "it": {
      "q": "Avete SUV di lusso disponibili?",
      "a": "Sì. SUV premium disponibili per famiglie, clientela business e consegne in hotel."
    },
    "nl": {
      "q": "Bieden jullie luxe SUV's aan?",
      "a": "Ja. Premium SUV's beschikbaar voor gezinnen, zakelijke ritten en hotellevering."
    },
    "pl": {
      "q": "Czy macie w ofercie luksusowe SUV-y?",
      "a": "Tak. Luksusowe SUV-y dostępne dla rodzin, klientów biznesowych oraz z dostawą do hotelu."
    }
  },
  "Can I rent a car monthly?": {
    "fr": {
      "q": "Puis-je louer un véhicule au mois ?",
      "a": "Oui. La location longue durée de luxe est disponible — demandez les tarifs mensuels en cours par WhatsApp."
    },
    "de": {
      "q": "Ist eine monatliche Anmietung möglich?",
      "a": "Ja. Luxus-Langzeitmiete ist möglich — fragen Sie per WhatsApp nach den aktuellen Monatspreisen."
    },
    "it": {
      "q": "È possibile noleggiare un'auto per un mese intero?",
      "a": "Sì. Il noleggio a lungo termine di lusso è disponibile — chiedi le tariffe mensili aggiornate via WhatsApp."
    },
    "nl": {
      "q": "Kan ik een auto voor een hele maand huren?",
      "a": "Ja. Luxe langetermijnverhuur is mogelijk — vraag de actuele maandtarieven op via WhatsApp."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód na miesiąc?",
      "a": "Tak. Długoterminowy wynajem luksusowych aut jest dostępny — zapytaj o aktualne stawki miesięczne przez WhatsApp."
    }
  },
  "Can I rent a premium car for one day?": {
    "fr": {
      "q": "Puis-je louer un véhicule premium pour une seule journée ?",
      "a": "Oui, les locations à la journée sont possibles selon le véhicule et la date souhaitée."
    },
    "de": {
      "q": "Kann ich einen Premiumwagen für nur einen Tag mieten?",
      "a": "Ja, Tagesmieten sind möglich, je nach Fahrzeug und Termin."
    },
    "it": {
      "q": "È possibile noleggiare un'auto premium per un solo giorno?",
      "a": "Sì, il noleggio giornaliero è disponibile in base al veicolo e alla data richiesta."
    },
    "nl": {
      "q": "Kan ik een premium auto voor slechts één dag huren?",
      "a": "Ja, dagverhuur is mogelijk afhankelijk van het voertuig en de gewenste datum."
    },
    "pl": {
      "q": "Czy można wynająć auto premium na jeden dzień?",
      "a": "Tak, wynajem jednodniowy jest możliwy w zależności od pojazdu i terminu."
    }
  },
  "Can I book by WhatsApp?": {
    "fr": {
      "q": "Puis-je réserver par WhatsApp ?",
      "a": "Oui. WhatsApp est notre canal privilégié pour une confirmation rapide."
    },
    "de": {
      "q": "Kann ich per WhatsApp buchen?",
      "a": "Ja. WhatsApp ist unser bevorzugter Kanal für eine schnelle Buchungsbestätigung."
    },
    "it": {
      "q": "Posso prenotare tramite WhatsApp?",
      "a": "Sì. WhatsApp è il nostro canale preferito per conferme rapide."
    },
    "nl": {
      "q": "Kan ik reserveren via WhatsApp?",
      "a": "Ja. WhatsApp is ons voorkeurkanaal voor snelle bevestiging."
    },
    "pl": {
      "q": "Czy mogę zarezerwować przez WhatsApp?",
      "a": "Tak. WhatsApp to nasz preferowany kanał – gwarantuje szybkie potwierdzenie rezerwacji."
    }
  },
  "What documents do I need to rent a luxury car in Spain?": {
    "fr": {
      "q": "Quels documents sont nécessaires pour louer une voiture de luxe en Espagne ?",
      "a": "Permis de conduire valide, passeport ou carte d'identité, et une carte de crédit pour la caution."
    },
    "de": {
      "q": "Welche Dokumente benötige ich für die Anmietung eines Luxusfahrzeugs in Spanien?",
      "a": "Gültiger Führerschein, Reisepass oder Personalausweis sowie eine Kreditkarte für die Kaution."
    },
    "it": {
      "q": "Quali documenti servono per noleggiare un'auto di lusso in Spagna?",
      "a": "Patente di guida valida, passaporto o documento d'identità e una carta di credito per il deposito."
    },
    "nl": {
      "q": "Welke documenten heb ik nodig om een luxe auto in Spanje te huren?",
      "a": "Geldig rijbewijs, paspoort of identiteitskaart en een creditcard voor de borgsom."
    },
    "pl": {
      "q": "Jakie dokumenty są wymagane do wynajmu luksusowego samochodu w Hiszpanii?",
      "a": "Ważne prawo jazdy, paszport lub dowód tożsamości oraz karta kredytowa na kaucję."
    }
  },
  "Is a deposit required?": {
    "fr": {
      "q": "Une caution est-elle exigée ?",
      "a": "Oui. Le montant dépend du véhicule et de la durée de location — il vous est confirmé à la réservation."
    },
    "de": {
      "q": "Wird eine Kaution verlangt?",
      "a": "Ja. Der Betrag richtet sich nach Fahrzeug und Mietdauer und wird bei der Buchung bestätigt."
    },
    "it": {
      "q": "È richiesto un deposito cauzionale?",
      "a": "Sì. L'importo varia in base al veicolo e al periodo di noleggio e viene comunicato al momento della prenotazione."
    },
    "nl": {
      "q": "Is er een borgsom vereist?",
      "a": "Ja. Het bedrag hangt af van het voertuig en de huurperiode en wordt bij boeking bevestigd."
    },
    "pl": {
      "q": "Czy wymagana jest kaucja?",
      "a": "Tak. Wysokość kaucji zależy od pojazdu i okresu wynajmu i zostaje potwierdzona przy rezerwacji."
    }
  },
  "Is insurance included?": {
    "fr": {
      "q": "L'assurance est-elle incluse ?",
      "a": "Oui, une assurance tous risques est incluse dans chaque location."
    },
    "de": {
      "q": "Ist eine Versicherung im Mietpreis enthalten?",
      "a": "Ja, jede Miete beinhaltet eine Vollkaskoversicherung."
    },
    "it": {
      "q": "L'assicurazione è inclusa nel noleggio?",
      "a": "Sì, ogni noleggio include un'assicurazione completa."
    },
    "nl": {
      "q": "Is de verzekering inbegrepen?",
      "a": "Ja, bij elke verhuur is een allriskverzekering inbegrepen."
    },
    "pl": {
      "q": "Czy ubezpieczenie jest wliczone w cenę?",
      "a": "Tak, każdy wynajem obejmuje pełne ubezpieczenie."
    }
  },
  "Can tourists rent a car?": {
    "fr": {
      "q": "Les touristes peuvent-ils louer un véhicule ?",
      "a": "Oui. Les touristes de l'UE et de nombreux pays hors UE sont acceptés — vérifiez votre situation au préalable."
    },
    "de": {
      "q": "Können Touristen ein Fahrzeug mieten?",
      "a": "Ja. Touristen aus der EU und vielen Nicht-EU-Ländern können mieten — bitte vorab bestätigen."
    },
    "it": {
      "q": "I turisti possono noleggiare un'auto?",
      "a": "Sì. I turisti provenienti dall'UE e da molti paesi extra-UE possono noleggiare — da confermare in anticipo."
    },
    "nl": {
      "q": "Kunnen toeristen een auto huren?",
      "a": "Ja. Toeristen uit de EU en veel niet-EU-landen kunnen huren — bevestig dit vooraf."
    },
    "pl": {
      "q": "Czy turyści mogą wynająć samochód?",
      "a": "Tak. Turyści z UE i wielu krajów spoza UE mogą wynajmować samochody — prosimy potwierdzić z wyprzedzeniem."
    }
  },
  "Can I rent with a foreign driving license?": {
    "fr": {
      "q": "Puis-je louer avec un permis de conduire étranger ?",
      "a": "Oui, avec un permis étranger valide. Certains permis non UE peuvent nécessiter un permis international."
    },
    "de": {
      "q": "Kann ich mit einem ausländischen Führerschein mieten?",
      "a": "Ja, mit einem gültigen ausländischen Führerschein. Für einige Nicht-EU-Führerscheine kann ein internationaler Führerschein erforderlich sein."
    },
    "it": {
      "q": "Posso noleggiare con una patente straniera?",
      "a": "Sì, con una patente straniera valida. Alcune patenti extra-UE potrebbero richiedere un permesso internazionale."
    },
    "nl": {
      "q": "Kan ik huren met een buitenlands rijbewijs?",
      "a": "Ja, met een geldig buitenlands rijbewijs. Voor sommige niet-EU-rijbewijzen kan een internationaal rijbewijs nodig zijn."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód z zagranicznym prawem jazdy?",
      "a": "Tak, z ważnym zagranicznym prawem jazdy. W przypadku niektórych praw jazdy spoza UE może być wymagane międzynarodowe prawo jazdy."
    }
  },
  "What is the fuel policy?": {
    "fr": {
      "q": "Quelle est la politique carburant ?",
      "a": "Plein pour plein. Les détails exacts sont confirmés avec chaque réservation."
    },
    "de": {
      "q": "Wie lautet die Kraftstoffregelung?",
      "a": "Volltank zu Volltank. Die genauen Details werden bei jeder Buchung bestätigt."
    },
    "it": {
      "q": "Qual è la politica sul carburante?",
      "a": "Pieno contro pieno. I dettagli vengono confermati al momento della prenotazione."
    },
    "nl": {
      "q": "Wat is het brandstofbeleid?",
      "a": "Vol voor vol. De exacte details worden bij elke boeking bevestigd."
    },
    "pl": {
      "q": "Jaka obowiązuje polityka paliwowa?",
      "a": "Pełny za pełny. Szczegóły potwierdzane są indywidualnie przy każdej rezerwacji."
    }
  },
  "Are rental conditions different for sports cars?": {
    "fr": {
      "q": "Les conditions de location varient-elles pour les voitures de sport ?",
      "a": "Les conditions et la caution peuvent varier selon le modèle — tout est précisé dans votre devis WhatsApp."
    },
    "de": {
      "q": "Gelten für Sportwagen andere Mietbedingungen?",
      "a": "Bedingungen und Kaution können je nach Modell variieren — Details werden in Ihrem WhatsApp-Angebot bestätigt."
    },
    "it": {
      "q": "Le condizioni di noleggio cambiano per le auto sportive?",
      "a": "Le condizioni e il deposito possono variare in base al modello — tutto viene specificato nel preventivo via WhatsApp."
    },
    "nl": {
      "q": "Gelden er andere huurvoorwaarden voor sportwagens?",
      "a": "Voorwaarden en borgsom kunnen per model verschillen — dit wordt bevestigd in uw WhatsApp-offerte."
    },
    "pl": {
      "q": "Czy warunki wynajmu różnią się w przypadku samochodów sportowych?",
      "a": "Warunki i kaucja mogą się różnić w zależności od modelu – szczegóły znajdziesz w wycenie przesłanej przez WhatsApp."
    }
  },
  "Can I rent if I am visiting from another country?": {
    "fr": {
      "q": "Puis-je louer un véhicule si je suis en vacances en Espagne ?",
      "a": "Oui. La majorité de nos clients sont des visiteurs étrangers. WhatsApp nous permet de tout confirmer avant votre arrivée."
    },
    "de": {
      "q": "Kann ich ein Fahrzeug mieten, wenn ich als Tourist in Spanien bin?",
      "a": "Ja. Die meisten unserer Kunden sind internationale Besucher. Per WhatsApp lässt sich alles vorab klären."
    },
    "it": {
      "q": "Posso noleggiare un'auto se sono in vacanza in Spagna?",
      "a": "Sì. La maggior parte dei nostri clienti sono visitatori internazionali. Con WhatsApp possiamo confermare tutto in anticipo."
    },
    "nl": {
      "q": "Kan ik een auto huren als ik op vakantie ben in Spanje?",
      "a": "Ja. De meeste van onze klanten zijn internationale bezoekers. Via WhatsApp bevestigen we alles vooraf."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód, będąc turystą w Hiszpanii?",
      "a": "Tak. Większość naszych klientów to goście z zagranicy. WhatsApp pozwala nam ustalić wszystkie szczegóły z wyprzedzeniem."
    }
  },
  "Do you deliver cars to hotels?": {
    "fr": {
      "q": "Livrez-vous les véhicules dans les hôtels ?",
      "a": "Oui, la livraison en hôtel est disponible à Benidorm, Alicante et sur la Costa Blanca — renseignez-vous par WhatsApp."
    },
    "de": {
      "q": "Liefern Sie Fahrzeuge zu Hotels?",
      "a": "Ja, Hotellieferung ist in Benidorm, Alicante und an der Costa Blanca verfügbar — fragen Sie per WhatsApp nach."
    },
    "it": {
      "q": "Consegnate le auto negli hotel?",
      "a": "Sì, la consegna in hotel è disponibile a Benidorm, Alicante e sulla Costa Blanca — chiedi via WhatsApp."
    },
    "nl": {
      "q": "Bezorgen jullie auto's bij hotels?",
      "a": "Ja, hotellevering is beschikbaar in Benidorm, Alicante en aan de Costa Blanca — vraag ernaar via WhatsApp."
    },
    "pl": {
      "q": "Czy dostarczacie samochody do hoteli?",
      "a": "Tak, dostawa do hotelu jest dostępna w Benidorm, Alicante i na Costa Blanca — zapytaj przez WhatsApp."
    }
  },
  "Can I collect the car at Alicante Airport?": {
    "fr": {
      "q": "Puis-je récupérer le véhicule à l'aéroport d'Alicante ?",
      "a": "La remise à l'aéroport peut être possible selon les disponibilités — confirmez par WhatsApp."
    },
    "de": {
      "q": "Kann ich das Fahrzeug am Flughafen Alicante abholen?",
      "a": "Die Übergabe am Flughafen kann je nach Zeitplan möglich sein — bitte per WhatsApp bestätigen."
    },
    "it": {
      "q": "Posso ritirare l'auto all'aeroporto di Alicante?",
      "a": "Il ritiro in aeroporto potrebbe essere disponibile in base agli orari — conferma via WhatsApp."
    },
    "nl": {
      "q": "Kan ik de auto ophalen op de luchthaven van Alicante?",
      "a": "Afhalen op de luchthaven kan mogelijk zijn afhankelijk van de planning — bevestig dit via WhatsApp."
    },
    "pl": {
      "q": "Czy mogę odebrać samochód na lotnisku w Alicante?",
      "a": "Odbiór na lotnisku może być możliwy w zależności od harmonogramu – potwierdź przez WhatsApp."
    }
  },
  "Do you serve Valencia or Murcia?": {
    "fr": {
      "q": "Intervenez-vous à Valence ou à Murcie ?",
      "a": "Oui, sur demande. La livraison à Valence ou à Murcie peut entraîner des frais supplémentaires."
    },
    "de": {
      "q": "Beliefern Sie auch Valencia oder Murcia?",
      "a": "Ja, auf Anfrage. Lieferungen nach Valencia oder Murcia können zusätzliche Kosten verursachen."
    },
    "it": {
      "q": "Operate anche a Valencia o Murcia?",
      "a": "Sì, su richiesta. La consegna a Valencia o Murcia potrebbe comportare costi aggiuntivi."
    },
    "nl": {
      "q": "Leveren jullie ook in Valencia of Murcia?",
      "a": "Ja, op aanvraag. Levering naar Valencia of Murcia kan extra kosten met zich meebrengen."
    },
    "pl": {
      "q": "Czy obsługujecie Walencję lub Murcję?",
      "a": "Tak, na życzenie. Dostawa do Walencji lub Murcji może wiązać się z dodatkowymi opłatami."
    }
  },
  "Do you deliver in Jávea, Dénia, Torrevieja or San Juan?": {
    "fr": {
      "q": "Livrez-vous à Jávea, Dénia, Torrevieja ou San Juan ?",
      "a": "Oui. La livraison sur la Costa Blanca est l'un de nos services phares."
    },
    "de": {
      "q": "Liefern Sie nach Jávea, Dénia, Torrevieja oder San Juan?",
      "a": "Ja. Die Belieferung der Costa Blanca ist einer unserer Kerndienste."
    },
    "it": {
      "q": "Consegnate a Jávea, Dénia, Torrevieja o San Juan?",
      "a": "Sì. La consegna sulla Costa Blanca è uno dei nostri servizi principali."
    },
    "nl": {
      "q": "Bezorgen jullie in Jávea, Dénia, Torrevieja of San Juan?",
      "a": "Ja. Levering aan de Costa Blanca is een van onze kernactiviteiten."
    },
    "pl": {
      "q": "Czy dostarczacie do Jávea, Dénia, Torrevieja lub San Juan?",
      "a": "Tak. Dostawa na Costa Blanca to jeden z naszych głównych serwisów."
    }
  },
  "Can the car be delivered to a villa?": {
    "fr": {
      "q": "Pouvez-vous livrer la voiture dans une villa ?",
      "a": "Oui, la livraison en villa est disponible sur toute la Costa Blanca."
    },
    "de": {
      "q": "Kann das Fahrzeug zu einer Villa geliefert werden?",
      "a": "Ja, Villenlieferung ist an der gesamten Costa Blanca verfügbar."
    },
    "it": {
      "q": "È possibile consegnare l'auto direttamente a una villa?",
      "a": "Sì, la consegna presso ville private è disponibile su tutta la Costa Blanca."
    },
    "nl": {
      "q": "Kunnen jullie de auto afleveren bij een villa?",
      "a": "Ja, levering bij een villa is mogelijk aan de hele Costa Blanca."
    },
    "pl": {
      "q": "Czy dostarczacie samochód bezpośrednio do willi?",
      "a": "Tak, dostawa do willi jest dostępna na całej Costa Blanca."
    }
  },
  "Do you serve Benidorm, Altea, Calpe and Finestrat?": {
    "fr": {
      "q": "Assurez-vous le service à Benidorm, Altea, Calpe et Finestrat ?",
      "a": "Oui. Ce sont nos zones de service principales."
    },
    "de": {
      "q": "Bedienen Sie auch Benidorm, Altea, Calpe und Finestrat?",
      "a": "Ja. Das sind unsere wichtigsten Servicegebiete."
    },
    "it": {
      "q": "Operate a Benidorm, Altea, Calpe e Finestrat?",
      "a": "Sì. Sono le nostre aree di servizio principali."
    },
    "nl": {
      "q": "Bedienen jullie ook Benidorm, Altea, Calpe en Finestrat?",
      "a": "Ja. Dit zijn onze belangrijkste servicegebieden."
    },
    "pl": {
      "q": "Czy obsługujecie Benidorm, Altea, Calpe i Finestrat?",
      "a": "Tak. To nasze główne strefy obsługi."
    }
  },
  "Can I ask for delivery options by WhatsApp?": {
    "fr": {
      "q": "Puis-je me renseigner sur les options de livraison par WhatsApp ?",
      "a": "Oui, WhatsApp est le moyen le plus rapide pour confirmer les options et les horaires de livraison."
    },
    "de": {
      "q": "Kann ich Lieferoptionen per WhatsApp erfragen?",
      "a": "Ja, WhatsApp ist der schnellste Weg, um Lieferoptionen und -zeiten zu bestätigen."
    },
    "it": {
      "q": "Posso richiedere informazioni sulle opzioni di consegna via WhatsApp?",
      "a": "Sì, WhatsApp è il modo più rapido per confermare le opzioni e i tempi di consegna."
    },
    "nl": {
      "q": "Kan ik via WhatsApp informeren naar de leveringsopties?",
      "a": "Ja, WhatsApp is de snelste manier om leveringsopties en tijden te bevestigen."
    },
    "pl": {
      "q": "Czy mogę zapytać o opcje dostawy przez WhatsApp?",
      "a": "Tak, WhatsApp to najszybszy sposób na potwierdzenie opcji i terminów dostawy."
    }
  },
  "Can I rent a car for a wedding?": {
    "fr": {
      "q": "Puis-je louer une voiture pour un mariage ?",
      "a": "Oui. Les locations pour mariage sont très demandées pour les arrivées, les séances photo et les transferts d'invités."
    },
    "de": {
      "q": "Kann ich ein Fahrzeug für eine Hochzeit mieten?",
      "a": "Ja. Hochzeitsmieten sind beliebt für Ankünfte, Fotoshootings und Gästetransfers."
    },
    "it": {
      "q": "Posso noleggiare un'auto per un matrimonio?",
      "a": "Sì. I noleggi per matrimoni sono molto richiesti per gli arrivi, i servizi fotografici e i trasferimenti degli ospiti."
    },
    "nl": {
      "q": "Kan ik een auto huren voor een bruiloft?",
      "a": "Ja. Bruidsauto's zijn populair voor aankomsten, fotoshoots en gastentransfers."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód na wesele?",
      "a": "Tak. Wynajem na wesele cieszy się dużą popularnością – na podjazd, sesję zdjęciową i transfery gości."
    }
  },
  "Can I rent a sports car for a birthday?": {
    "fr": {
      "q": "Puis-je louer une voiture de sport pour un anniversaire ?",
      "a": "Oui. Les cadeaux-surprises avec voiture de sport sont très courants — contactez-nous pour les options disponibles."
    },
    "de": {
      "q": "Kann ich für einen Geburtstag einen Sportwagen mieten?",
      "a": "Ja. Sportwagen als Geburtstagsüberraschung sind ein häufiger Wunsch — fragen Sie nach den Möglichkeiten."
    },
    "it": {
      "q": "Posso noleggiare una sportiva per un compleanno?",
      "a": "Sì. I regali a sorpresa con auto sportiva sono molto comuni — chiedici le opzioni disponibili."
    },
    "nl": {
      "q": "Kan ik een sportwagen huren voor een verjaardag?",
      "a": "Ja. Een sportwagen als verjaardagsverrassing is heel gebruikelijk — vraag naar de mogelijkheden."
    },
    "pl": {
      "q": "Czy mogę wynająć sportowe auto na urodziny?",
      "a": "Tak. Sportowy samochód jako niespodzianka urodzinowa to popularny pomysł – zapytaj o dostępne opcje."
    }
  },
  "Can I use a luxury car for a photoshoot?": {
    "fr": {
      "q": "Puis-je utiliser un véhicule de luxe pour une séance photo ?",
      "a": "Oui. Des locations pour séances photo et création de contenu sont disponibles sur toute la Costa Blanca."
    },
    "de": {
      "q": "Kann ich ein Luxusfahrzeug für ein Fotoshooting nutzen?",
      "a": "Ja. Fahrzeuge für Fotoshootings und Content-Produktionen stehen an der Costa Blanca zur Verfügung."
    },
    "it": {
      "q": "Posso usare un'auto di lusso per un servizio fotografico?",
      "a": "Sì. Il noleggio per servizi fotografici e creazione di contenuti è disponibile su tutta la Costa Blanca."
    },
    "nl": {
      "q": "Kan ik een luxe auto gebruiken voor een fotoshoot?",
      "a": "Ja. Verhuur voor fotoshoots en contentcreatie is beschikbaar aan de Costa Blanca."
    },
    "pl": {
      "q": "Czy mogę wynająć luksusowe auto na sesję zdjęciową?",
      "a": "Tak. Wynajem na sesje zdjęciowe i tworzenie treści dostępny na całej Costa Blanca."
    }
  },
  "Can I rent a car for a music video?": {
    "fr": {
      "q": "Puis-je louer un véhicule pour un clip vidéo ?",
      "a": "Oui. Les locations pour clips vidéo et productions publicitaires sont les bienvenues."
    },
    "de": {
      "q": "Kann ich ein Fahrzeug für ein Musikvideo mieten?",
      "a": "Ja. Fahrzeuge für Musikvideos und Werbeproduktionen sind willkommen."
    },
    "it": {
      "q": "Posso noleggiare un'auto per un videoclip musicale?",
      "a": "Sì. Il noleggio per videoclip e produzioni pubblicitarie è disponibile."
    },
    "nl": {
      "q": "Kan ik een auto huren voor een muziekvideo?",
      "a": "Ja. Verhuur voor muziekvideo's en reclameopnames is mogelijk."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód do teledysku?",
      "a": "Tak. Wynajem do teledysków i produkcji reklamowych jest jak najbardziej możliwy."
    }
  },
  "What car is best for a Costa Blanca road trip?": {
    "fr": {
      "q": "Quelle voiture choisir pour un road trip sur la Costa Blanca ?",
      "a": "Un SUV de luxe pour le confort, un GT performance pour les virages et une muscle car pour le caractère."
    },
    "de": {
      "q": "Welches Fahrzeug eignet sich am besten für einen Road Trip an der Costa Blanca?",
      "a": "Ein Luxus-SUV für Komfort, ein Performance-GT für Kurven und ein Muscle Car für den besonderen Charakter."
    },
    "it": {
      "q": "Quale auto è più adatta per un road trip sulla Costa Blanca?",
      "a": "Un SUV di lusso per il comfort, una GT ad alte prestazioni per le curve e una muscle car per il carattere."
    },
    "nl": {
      "q": "Welke auto is het beste voor een roadtrip aan de Costa Blanca?",
      "a": "Een luxe SUV voor comfort, een performance GT voor de bochten en een muscle car voor de persoonlijkheid."
    },
    "pl": {
      "q": "Jaki samochód wybrać na road trip po Costa Blanca?",
      "a": "Luksusowy SUV dla komfortu, sportowe GT dla krętych dróg i muscle car dla charakteru."
    }
  },
  "Can I rent a car for a business trip?": {
    "fr": {
      "q": "Puis-je louer un véhicule pour un déplacement professionnel ?",
      "a": "Oui. Les locations executives et CEO font partie de nos services."
    },
    "de": {
      "q": "Kann ich ein Fahrzeug für eine Geschäftsreise mieten?",
      "a": "Ja. Executive- und CEO-Mietfahrzeuge gehören zu unserem Angebot."
    },
    "it": {
      "q": "Posso noleggiare un'auto per un viaggio di lavoro?",
      "a": "Sì. I noleggi executive e per CEO rientrano tra i nostri servizi."
    },
    "nl": {
      "q": "Kan ik een auto huren voor een zakenreis?",
      "a": "Ja. Executive- en CEO-verhuur maakt deel uit van ons dienstenaanbod."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód na wyjazd służbowy?",
      "a": "Tak. Wynajem reprezentacyjny i dla kadry zarządzającej jest częścią naszej oferty."
    }
  },
  "Can I rent a premium car for a hotel arrival?": {
    "fr": {
      "q": "Puis-je louer un véhicule premium pour arriver en grand style à un hôtel ?",
      "a": "Oui. L'arrivée en hôtel est l'une des raisons les plus fréquentes pour lesquelles nos clients font appel à nous."
    },
    "de": {
      "q": "Kann ich ein Premiumfahrzeug mieten, um stilvoll zu einem Hotel zu fahren?",
      "a": "Ja. Die Hotelanfahrt ist einer der häufigsten Gründe, warum unsere Kunden bei uns buchen."
    },
    "it": {
      "q": "Posso noleggiare un'auto premium per arrivare in grande stile a un hotel?",
      "a": "Sì. L'arrivo in hotel è uno dei motivi più comuni per cui i nostri clienti prenotano."
    },
    "nl": {
      "q": "Kan ik een premium auto huren om in stijl bij een hotel aan te komen?",
      "a": "Ja. Een stijlvolle aankomst bij een hotel is een van de meest voorkomende redenen waarom klanten bij ons boeken."
    },
    "pl": {
      "q": "Czy mogę wynająć auto premium na efektowny przyjazd do hotelu?",
      "a": "Tak. Efektowny przyjazd do hotelu to jeden z najczęstszych powodów, dla których klienci się do nas zgłaszają."
    }
  },
  "Can I rent a car for content creation?": {
    "fr": {
      "q": "Puis-je louer un véhicule pour créer du contenu ?",
      "a": "Oui. Nous accueillons chaque saison des créateurs, influenceurs et équipes de marque."
    },
    "de": {
      "q": "Kann ich ein Fahrzeug für Content-Produktionen mieten?",
      "a": "Ja. Jede Saison arbeiten wir mit Creatorn, Influencern und Markenteams zusammen."
    },
    "it": {
      "q": "Posso noleggiare un'auto per la creazione di contenuti?",
      "a": "Sì. Ogni stagione collaboriamo con creator, influencer e team di brand."
    },
    "nl": {
      "q": "Kan ik een auto huren voor contentcreatie?",
      "a": "Ja. Elk seizoen werken we samen met creators, influencers en merkteams."
    },
    "pl": {
      "q": "Czy mogę wynająć samochód do tworzenia contentu?",
      "a": "Tak. Każdego sezonu współpracujemy z twórcami, influencerami i zespołami brandowymi."
    }
  }
};

const F = (en, es, ru, ae, as_, ar) => {
  const localized = FAQ_TRANSLATIONS[en] || {};
  return {
    q: { en, es, ru, ...Object.fromEntries(Object.entries(localized).map(([lang, copy]) => [lang, copy.q])) },
    a: { en: ae, es: as_, ru: ar, ...Object.fromEntries(Object.entries(localized).map(([lang, copy]) => [lang, copy.a])) },
  };
};


const FAQ_CATEGORY_TRANSLATIONS = {
  "availability": {
    "fr": "Location et disponibilité",
    "de": "Vermietung und Verfügbarkeit",
    "it": "Noleggio e disponibilità",
    "nl": "Verhuur en beschikbaarheid",
    "pl": "Wynajem i dostępność"
  },
  "documents": {
    "fr": "Documents et conditions",
    "de": "Dokumente und Bedingungen",
    "it": "Documenti e condizioni",
    "nl": "Documenten en voorwaarden",
    "pl": "Dokumenty i warunki"
  },
  "delivery": {
    "fr": "Livraison et zones de service",
    "de": "Lieferung und Servicegebiete",
    "it": "Consegna e aree di servizio",
    "nl": "Bezorging en servicegebieden",
    "pl": "Dostawa i strefy obsługi"
  },
  "events": {
    "fr": "Événements et expériences",
    "de": "Events und Erlebnisse",
    "it": "Eventi ed esperienze",
    "nl": "Evenementen en belevenissen",
    "pl": "Eventy i wyjątkowe okazje"
  }
};
FAQ_CATEGORIES.forEach((category) => {
  Object.assign(category.title, FAQ_CATEGORY_TRANSLATIONS[category.key] || {});
});

export const FAQ_ITEMS = {
  availability: [
    F("Where can I rent a luxury car in Benidorm?", "¿Dónde alquilar un coche de lujo en Benidorm?", "Где арендовать премиальный автомобиль в Бенидорме?",
      "Book directly with us by WhatsApp. Pickup and delivery options across Benidorm and Costa Blanca.",
      "Reserva directamente por WhatsApp. Opciones de recogida y entrega en Benidorm y Costa Blanca.",
      "Бронирование напрямую через WhatsApp. Получение и доставка по Бенидорму и Коста-Бланке."),
    F("Can I rent a sports car in Alicante?", "¿Puedo alquilar un coche deportivo en Alicante?", "Можно ли арендовать спорткар в Аликанте?",
      "Yes. We serve clients across Alicante, San Juan, El Campello and Villajoyosa.",
      "Sí. Atendemos clientes en Alicante, San Juan, El Campello y Villajoyosa.",
      "Да. Мы обслуживаем Аликанте, Сан-Хуан, Эль-Кампельо и Вильяхойосу."),
    F("Do you rent cars in Costa Blanca?", "¿Alquiláis coches en Costa Blanca?", "Работаете ли вы на Коста-Бланке?",
      "Yes. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja and surrounding areas.",
      "Sí. Benidorm, Alicante, Altea, Calpe, Moraira, Jávea, Dénia, Torrevieja y alrededores.",
      "Да. Бенидорм, Аликанте, Альтеа, Кальпе, Морайра, Хавеа, Дения, Торревьеха и окрестности."),
    F("Can I rent an American muscle car in Spain?", "¿Puedo alquilar un muscle car americano en España?", "Можно ли арендовать американский muscle car в Испании?",
      "Yes. Dodge Challenger, Dodge Charger and Chevrolet Camaro are part of our typical fleet.",
      "Sí. Dodge Challenger, Dodge Charger y Chevrolet Camaro suelen formar parte de la flota.",
      "Да. Dodge Challenger, Dodge Charger и Chevrolet Camaro обычно есть в парке."),
    F("Do you offer luxury SUVs?", "¿Tenéis SUV de lujo?", "Есть ли премиальные SUV?",
      "Yes. Premium SUVs are available for families, business and hotel deliveries.",
      "Sí. Tenemos SUV premium para familias, negocios y entregas en hotel.",
      "Да. Премиальные SUV для семей, бизнеса и доставки в отель."),
    F("Can I rent a car monthly?", "¿Puedo alquilar un coche mensual?", "Можно ли арендовать на месяц?",
      "Yes. Monthly luxury rental is available — ask for current monthly rates by WhatsApp.",
      "Sí. Alquiler mensual de lujo disponible — pide tarifas mensuales por WhatsApp.",
      "Да. Месячная премиальная аренда — запросите тарифы в WhatsApp."),
    F("Can I rent a premium car for one day?", "¿Puedo alquilar un coche premium por un día?", "Можно ли арендовать премиальный авто на один день?",
      "Yes, single-day rentals are possible depending on the vehicle and date.",
      "Sí, alquileres de un día disponibles según vehículo y fecha.",
      "Да, аренда на один день — в зависимости от автомобиля и даты."),
    F("Can I book by WhatsApp?", "¿Puedo reservar por WhatsApp?", "Можно ли забронировать через WhatsApp?",
      "Yes. WhatsApp is our preferred channel for fast confirmation.",
      "Sí. WhatsApp es nuestro canal preferido para confirmación rápida.",
      "Да. WhatsApp — наш предпочтительный канал."),
  ],
  documents: [
    F("What documents do I need to rent a luxury car in Spain?", "¿Qué documentos necesito para alquilar un coche de lujo en España?", "Какие документы нужны для аренды премиального автомобиля в Испании?",
      "Valid driving license, passport / ID and a credit card for the deposit.",
      "Carnet de conducir válido, pasaporte/DNI y tarjeta de crédito para la fianza.",
      "Действительные права, паспорт и кредитная карта для депозита."),
    F("Is a deposit required?", "¿Hace falta fianza?", "Нужен ли депозит?",
      "Yes. Amount depends on the vehicle and rental period — confirmed at booking.",
      "Sí. Importe según vehículo y período — se confirma en la reserva.",
      "Да. Сумма зависит от автомобиля и срока."),
    F("Is insurance included?", "¿El seguro está incluido?", "Включена ли страховка?",
      "Yes, full insurance is included in every rental.",
      "Sí, seguro a todo riesgo incluido en cada alquiler.",
      "Да, полная страховка включена."),
    F("Can tourists rent a car?", "¿Pueden alquilar turistas?", "Могут ли туристы арендовать автомобиль?",
      "Yes. Tourists from EU and many non-EU countries can rent — confirm beforehand.",
      "Sí. Turistas de la UE y muchos países no UE pueden alquilar — confirma antes.",
      "Да. Туристы из ЕС и многих других стран — уточните заранее."),
    F("Can I rent with a foreign driving license?", "¿Puedo alquilar con carnet extranjero?", "Можно ли с иностранными правами?",
      "Yes, with a valid foreign license. Some non-EU licenses may need an international permit.",
      "Sí, con carnet extranjero válido. Algunos no UE pueden requerir permiso internacional.",
      "Да, с действительными иностранными правами. Иногда требуется международное удостоверение."),
    F("What is the fuel policy?", "¿Cuál es la política de combustible?", "Какая политика топлива?",
      "Full-to-full. We confirm exact details with each booking.",
      "Mismo nivel a la devolución que en la recogida. Confirmamos los detalles en cada reserva.",
      "С полного бака на полный. Уточняется при бронировании."),
    F("Are rental conditions different for sports cars?", "¿Las condiciones cambian en coches deportivos?", "Отличаются ли условия для спорткаров?",
      "Conditions and deposit can vary by model — we confirm in your WhatsApp quote.",
      "Las condiciones y fianza pueden variar por modelo — se confirma en tu cotización.",
      "Условия и депозит могут отличаться — указываются в коммерческом предложении."),
    F("Can I rent if I am visiting from another country?", "¿Puedo alquilar si estoy de vacaciones en España?", "Можно ли арендовать, если я приехал из другой страны?",
      "Yes. Many of our clients are international visitors. WhatsApp lets us confirm everything in advance.",
      "Sí. Muchos clientes son visitantes internacionales. WhatsApp permite confirmar todo de antemano.",
      "Да. Многие клиенты — гости из других стран. WhatsApp позволяет всё подтвердить заранее."),
  ],
  delivery: [
    F("Do you deliver cars to hotels?", "¿Entregáis coches en hoteles?", "Доставляете ли в отели?",
      "Hotel delivery is available across Benidorm, Alicante and Costa Blanca — ask by WhatsApp.",
      "Entrega en hotel disponible en Benidorm, Alicante y Costa Blanca — pregunta por WhatsApp.",
      "Доставка в отель доступна в Бенидорме, Аликанте и на Коста-Бланке."),
    F("Can I collect the car at Alicante Airport?", "¿Puedo recoger el coche en el aeropuerto de Alicante?", "Можно ли получить автомобиль в аэропорту Аликанте?",
      "Airport pickup may be available depending on schedule — confirm by WhatsApp.",
      "Recogida en aeropuerto puede estar disponible según horario — confirma por WhatsApp.",
      "Получение в аэропорту — по запросу в WhatsApp."),
    F("Do you serve Valencia or Murcia?", "¿Trabajáis en Valencia o Murcia?", "Работаете ли вы в Валенсии или Мурсии?",
      "Yes, by request. Delivery to Valencia or Murcia may include additional fees.",
      "Sí, bajo petición. La entrega en Valencia o Murcia puede incluir costes adicionales.",
      "Да, по запросу. Доставка в Валенсию или Мурсию может быть платной."),
    F("Do you deliver in Jávea, Dénia, Torrevieja or San Juan?", "¿Entregáis en Jávea, Dénia, Torrevieja o San Juan?", "Доставляете ли в Хавеа, Дению, Торревьеху или Сан-Хуан?",
      "Yes. Costa Blanca delivery is one of our core services.",
      "Sí. La entrega en Costa Blanca es uno de nuestros servicios principales.",
      "Да. Доставка по Коста-Бланке — наш базовый сервис."),
    F("Can the car be delivered to a villa?", "¿Podéis entregar el coche en una villa?", "Можно ли доставить автомобиль на виллу?",
      "Yes, villa delivery is available across Costa Blanca.",
      "Sí, entrega en villa disponible en Costa Blanca.",
      "Да, доставка на виллы по Коста-Бланке."),
    F("Do you serve Benidorm, Altea, Calpe and Finestrat?", "¿Trabajáis en Benidorm, Altea, Calpe y Finestrat?", "Работаете ли в Бенидорме, Альтее, Кальпе и Финестрате?",
      "Yes. These are core service areas.",
      "Sí. Son zonas de servicio principales.",
      "Да. Это базовые зоны обслуживания."),
    F("Can I ask for delivery options by WhatsApp?", "¿Puedo consultar las opciones de entrega por WhatsApp?", "Можно ли уточнить доставку через WhatsApp?",
      "Yes, WhatsApp is the fastest way to confirm delivery options and timing.",
      "Sí, WhatsApp es la forma más rápida de confirmar opciones y horarios de entrega.",
      "Да, WhatsApp — самый быстрый способ уточнить детали доставки."),
  ],
  events: [
    F("Can I rent a car for a wedding?", "¿Puedo alquilar un coche para una boda?", "Можно ли арендовать автомобиль для свадьбы?",
      "Yes. Wedding rentals are popular for arrivals, photoshoots and guest transfers.",
      "Sí. Las bodas son habituales para llegadas, sesiones de fotos y traslados.",
      "Да. Свадебная аренда популярна для приездов, фото и трансферов."),
    F("Can I rent a sports car for a birthday?", "¿Puedo alquilar un deportivo para un cumpleaños?", "Можно ли спорткар на день рождения?",
      "Yes. Sports car gifts and birthday rentals are common — ask for options.",
      "Sí. Los regalos sorpresa con deportivos son habituales — consúltanos.",
      "Да. Подарки-сюрпризы со спорткаром — обычное дело."),
    F("Can I use a luxury car for a photoshoot?", "¿Puedo usar un coche de lujo para una sesión de fotos?", "Можно ли использовать премиум-авто для фотосессии?",
      "Yes. Photoshoot and content creation rentals are available across Costa Blanca.",
      "Sí. Alquileres para sesiones de fotos y contenido en Costa Blanca.",
      "Да. Аренда для фотосессий и контента по Коста-Бланке."),
    F("Can I rent a car for a music video?", "¿Puedo alquilar un coche para un videoclip?", "Можно ли арендовать для клипа?",
      "Yes. Music video and ad production rentals are welcome.",
      "Sí. Alquileres para videoclips y producción publicitaria bienvenidos.",
      "Да. Аренда для клипов и рекламных съёмок приветствуется."),
    F("What car is best for a Costa Blanca road trip?", "¿Qué coche es mejor para una ruta por Costa Blanca?", "Какой автомобиль лучше для маршрута по Коста-Бланке?",
      "A luxury SUV for comfort, a performance GT for curves and a muscle car for personality.",
      "Un SUV de lujo para confort, un GT performance para curvas y un muscle car para personalidad.",
      "Премиальный SUV — для комфорта, GT — для поворотов, muscle car — для характера."),
    F("Can I rent a car for a business trip?", "¿Puedo alquilar un coche para un viaje de negocios?", "Можно ли арендовать для деловой поездки?",
      "Yes. Executive and CEO rentals are part of our service.",
      "Sí. Alquileres ejecutivos forman parte de nuestro servicio.",
      "Да. Представительская аренда — часть нашего сервиса."),
    F("Can I rent a premium car for a hotel arrival?", "¿Puedo alquilar un coche premium para llegar a un hotel?", "Можно ли арендовать премиум для приезда в отель?",
      "Yes. Hotel arrivals are one of the most common reasons our clients book.",
      "Sí. Las llegadas a hotel son una de las razones más comunes para reservar.",
      "Да. Приезд в отель — одна из самых частых причин аренды."),
    F("Can I rent a car for content creation?", "¿Puedo alquilar un coche para crear contenido?", "Можно ли арендовать для создания контента?",
      "Yes. We host creators, influencers and brand teams every season.",
      "Sí. Cada temporada trabajamos con creadores, influencers y marcas.",
      "Да. Каждый сезон мы работаем с креаторами и брендами."),
  ],
};

export const BRAND_DISCLAIMER_FAQ = {
  en: "We may mention brands such as Ferrari, Lamborghini, BMW, Mercedes G-Class, Jeep Wagoneer, Rolls-Royce or Bentley because many clients search for these vehicles. Availability changes and not every model is in the current fleet. Contact us by WhatsApp to check current cars and alternatives.",
  es: "Podemos mencionar marcas como Ferrari, Lamborghini, BMW, Mercedes Clase G, Jeep Wagoneer, Rolls-Royce o Bentley porque muchos clientes las buscan. La disponibilidad cambia y no todos los modelos forman parte de la flota actual. Contáctanos por WhatsApp.",
  ru: "Мы можем упоминать Ferrari, Lamborghini, BMW, Mercedes G-Class, Jeep Wagoneer, Rolls-Royce и Bentley, потому что их ищут клиенты. Доступность меняется и не каждая модель есть в текущем парке. Напишите в WhatsApp.",
};

Object.assign(BRAND_DISCLAIMER_FAQ, {
  "fr": "Nous pouvons mentionner des marques telles que Ferrari, Lamborghini, BMW, Mercedes Classe G, Jeep Wagoneer, Rolls-Royce ou Bentley, car de nombreux clients les recherchent. La disponibilité évolue et tous les modèles ne font pas nécessairement partie de la flotte actuelle. Contactez-nous par WhatsApp pour connaître les véhicules disponibles et les alternatives.",
  "de": "Wir erwähnen gelegentlich Marken wie Ferrari, Lamborghini, BMW, Mercedes G-Klasse, Jeep Wagoneer, Rolls-Royce oder Bentley, da viele Kunden gezielt nach diesen Modellen suchen. Die Verfügbarkeit ändert sich und nicht jedes Fahrzeug befindet sich aktuell in der Flotte. Schreiben Sie uns per WhatsApp für aktuelle Fahrzeuge und Alternativen.",
  "it": "Potremmo citare marchi come Ferrari, Lamborghini, BMW, Mercedes Classe G, Jeep Wagoneer, Rolls-Royce o Bentley perché molti clienti li cercano. La disponibilità cambia e non tutti i modelli fanno parte della flotta attuale. Contattaci via WhatsApp per verificare i veicoli disponibili e le alternative.",
  "nl": "Wij kunnen merken noemen zoals Ferrari, Lamborghini, BMW, Mercedes G-Klasse, Jeep Wagoneer, Rolls-Royce of Bentley, omdat veel klanten hier specifiek naar zoeken. De beschikbaarheid wisselt en niet elk model maakt deel uit van het huidige wagenpark. Neem contact op via WhatsApp voor actuele beschikbaarheid en alternatieven.",
  "pl": "Możemy wymieniać marki takie jak Ferrari, Lamborghini, BMW, Mercedes G-Class, Jeep Wagoneer, Rolls-Royce czy Bentley, ponieważ wielu klientów ich szuka. Dostępność zmienia się i nie każdy model znajduje się w aktualnej flocie. Napisz do nas przez WhatsApp, aby sprawdzić dostępne pojazdy i alternatywy."
});
